import { Component, OnInit } from '@angular/core';
import * as appConstants from '../../assets/json/applicationConstants.json';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit {
  
  brandData = appConstants?.commonAppConstants?.brandData;

  constructor() { }

  ngOnInit(): void {
  }

}
